<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Collapse',
    props: {
        value: {
            type: Boolean,
            default: undefined,
        },
        caret: {
            type: String,
            default: 'fa-solid fa-chevron-down',
        },
        headerClass: {
            type: String,
            default: undefined,
        },
        slim: Boolean,
        disable: Boolean,
        readOnly: Boolean,
        fade: Boolean,
        openOnLoad: Boolean,
    },
    data() {
        return {
            open: false,
        }
    },
    computed: {
        ...mapGetters(['lgDevice']),
        isOpen() {
            return this.value !== undefined ? this.value : this.open
        },
    },
    mounted() {
        if (this.openOnLoad) {
            if (this.value !== undefined) this.$emit('input', this.openOnLoad)
            this.open = this.openOnLoad
        }
    },
    methods: {
        toggle() {
            if (!this.disable && !this.readOnly) {
                if (this.value !== undefined) {
                    this.$emit('input', !this.value)
                    this.open = this.value
                } else this.open = !this.open
            }
        },
        openBox() {
            if (!this.disable && !this.readOnly) {
                this.open = true
                if (this.value !== undefined) this.$emit('input', true)
            }
        },
        closeBox() {
            if (!this.disable && !this.readOnly) {
                this.open = false
                if (this.value !== undefined) this.$emit('input', false)
            }
        },
        remove(e) {
            e.stopPropagation()
            if (!this.disable) this.$emit('delete')
        },
        edit(e) {
            e.stopPropagation()
            if (!this.disable) this.$emit('edit')
        },
    },
}
</script>

<template lang="pug">
.collapse-box(:class="{'collapse-box-slim': slim}")
    div(
        v-if="$slots.header"
        @click="toggle"
        :class="[headerClass ? headerClass : 'header', {'p-0': slim, 'cursor-pointer': !readOnly && !disable, 'not-collapsed': isOpen}]")
        slot(name='header')
        transition(name="fade")
            icon.collapse-box-caret(v-if="!readOnly && !disable" :class="{'font-size-micro': lgDevice}" :icon="caret" size="xs")
    transition(name="collapse-box-open")
        .collapse-box-body.grid(v-if="isOpen || readOnly")
            .overflow-hidden
                slot
</template>
